import type { Country } from "./country";
import type { Dsp } from "./dsp";
import type { Release } from "./release";
import type { ReleaseEntry } from "./release-entry";
import type { ServiceIssue } from "./service-issue";

export type ReleaseCandidateBase = {
  audioUid: string | null;
  collectionUid: string | null;
  coverImagePath: string | null;
  durationInSeconds?: number | null;
  subtitle: string | null;
  title: string;
  isSingle: boolean;
  isUsed: boolean;
  issues: Array<ServiceIssue>;
};

export type ReleaseCandidateDetails = ReleaseCandidateBase & {
  albumPriceCategoryId: number;
  dsps: Array<Dsp>;
  entries: Array<ReleaseEntry>;
  excludedCountries: Array<Country>;
  originalReleaseDate: string | null;
  preferredReleaseDate: string | null;
  trackPriceCategoryId: number;
};

export type ReleaseCandidateInList = ReleaseCandidateBase & {
  entries: Array<ReleaseEntry & { path: string }>;
};

export function isReleaseCandidate(
  release: Release | ReleaseCandidateBase | undefined,
): release is ReleaseCandidateBase {
  return !!release && !("uid" in release);
}
